import { createFileRoute } from '@tanstack/react-router';
import { ResourceAuditTrail } from '../../../features/audit/components/ResourceAuditTrail';
import { usePageTitle } from '../../../lib/hooks.js';
import { PageHeader } from '../../../components/layout/PageHeader';

export const Route = createFileRoute("/_auth/audit/resource/$type/$id")({
  component: ResourceAuditTrailPage,
});

function ResourceAuditTrailPage() {
  usePageTitle('Resource Audit Trail');
  const { type, id } = Route.useParams();
  
  return (
    <div className="flex flex-col gap-6 h-full overflow-hidden">
      <PageHeader
        title="Resource Audit Trail"
        subtitle={`History of events for ${type}: ${id}`}
      />
      
      <div className="flex-1 min-h-0 bg-surface-1 border border-surface-3 rounded-sm overflow-hidden p-4">
        <ResourceAuditTrail resourceType={type} resourceId={id} />
      </div>
    </div>
  );
}
